import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import "../../assets/css/faq.css";
import faq from "../../assets/img/landing/faq.svg";
import termicon from "../../assets/img/terms-con.svg";
import search from "../../assets/img/sreach---icon.svg";
import { getFaq, getPageContents } from "../../services/apiOtherlink";
const PrivacyPopup = (props) => {
 const [privacyContent, setPrivacyContent] = useState('');
 useEffect(() => {
       fetchContent()
     }, [])
  
     const fetchContent = async () => {
         let content = await getPageContents();
        
          setPrivacyContent(content.privacyPolicy.template);
     
       }
    const privacyClosePopup = () => {
    props.privacyClosePopup();
   
  };
  return (
    <div>
         <Modal dialogClassName="custom-modal modal-dialog-centered modal-dialog-scrollable" show={props.privacyOpenPopup} onHide={privacyClosePopup}>
           <Modal.Header closeButton>
             <div className="popupheader">
               <div className="mod-bor-icon" >
                 <img src={termicon} className="mod-icon black"></img>
               </div>
               <div className="header">
                 <h4 className="modal-tittle">Privacy Policy</h4>
   
               </div>
             </div>
           </Modal.Header>
   
           <Modal.Body>
            <div className="succ-content" dangerouslySetInnerHTML={{ __html: privacyContent}} /> 

  <style>{`
        .tc { list-style: none; padding-left: 0; }
        .mt-3 { margin-top: 1rem; }
        .sub-t-c { margin-top: 0.25rem; }
        ul.tc li ol li {
    list-style: auto;
        margin-bottom: 10px;
}
        ul.tc ol {
    padding-left: 16px !important;
    margin-bottom: 0px;
}
      `}</style>
    {/* <div class="">
        <div class="row ">
          <div class="col-lg-6 my-2 ">
            <div class="d-flex mb-3 ">
              <div class=" search-box search-wrapper  d-flex align-items-center px-2 gap-2">
                <span className="mobil-view-class border-end-0 ">
                  <img src={search} alt="search--Logo" className="search-logo-header mob-view-class pagess" />
                </span>
                <input type="text" class=" form-control border-start-0 search-inputs search-inside-color" placeholder="Search here"
                  onChange={(e) => { setSearchKey(e.target.value) }} value={searchKey} />
              </div>
            </div>
          </div>
        </div>


        <div class="row ">


          <div className="col-md-12">
            <div class="accordion popup" id="customAccordion">

              <div className="accordion" id="customAccordion">
                {faqArr.map((faQue, index) => (
                  <div className="accordion-item" key={index}>
                    <h2 className="accordion-header" id={`heading${index}`}>
                      <button
                        className="accordion-button collapsed d-flex align-items-center"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse${index}`}  
                        aria-expanded="false"
                        aria-controls={`collapse${index}`}
                      >
                        <div className="icon-text-wrapper">
                          <span className="custom-icon"></span>
                          <span className="custom-text">{faQue.question}</span>
                        </div>
                      </button>
                    </h2>
                    <div
                      id={`collapse${index}`}
                      className="accordion-collapse collapse"
                      aria-labelledby={`heading${index}`}
                      data-bs-parent="#customAccordion"
                    >
                      <div className="accordion-body">{faQue.answer}</div>
                    </div>
                  </div>
                ))}
              </div>       
            </div>
          </div>
        </div>


      </div> */}
           </Modal.Body>
           <Modal.Footer className="full-w" >
           
           </Modal.Footer>
         </Modal>
         
       </div>
  );
};
export default PrivacyPopup;